import { Chip } from "@mui/material";
import _ from "lodash";

const Type = ({ title }) => {
  const color =
    title == "prescription" ? "secondaryGreen.main" : "primary.main";
  const label = title == "prescription" ? "RECETA" : "ORDEN";
  return (
    <Chip
      sx={{ color: color, borderColor: color, width: "fit-content" }}
      label={label}
      variant="outlined"
    />
  );
};

export default Type;